import React, { Fragment } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "redux/GeneralReducers/GeneralActions";
import { getRequest } from "config/axios";
import Buttons from "components/body/buttons/Button";

const ModalContent = (props) => {
  const dispatch = useDispatch();
  const { GeneralReducers: { loading } } = useSelector((state) => state);
  const { data, setModal, getList } = props;

  const deleteData = async (id) => {
    dispatch(setLoading(true));
    try {
      getRequest(`egs/mail/${id}/delete`);
      // dispatch(setLoading(false));
      getList()
      setModal({ modal: false })
    } catch (error) {
      dispatch(setLoading(false))
      console.log("error", error)
    }
  }

  return (
    <Fragment>
      <Modal
        show={data.modal}
        onHide={() => setModal({ modal: false })}
        aria-labelledby="example-modal-sizes-title-lg"
        animation={false}
      >
        <Modal.Header className="header-modal" closeButton>
          <Modal.Title
            className="title-modal"
            id="example-modal-sizes-title-lg"
          >
            Delete Surat
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row reset-margin-row">
            <div className="col-md-12 content-modal">
              <div className="container-fluid">
                Apakah anda yakin akan menghapus kop surat ini ?
              </div>
            </div>
          </div>
          <hr />
          <div className="row reset-margin-row ">
            <div className="col-md-12 text-right mb-3">
              <Buttons
                className="btn btn-danger pull-left"
                onClick={() => deleteData(data.id)}
                disabled={loading}
              >
                {loading ?
                  <i className="fa fa-spinner fa-pulse fa-fw cover-empty"></i>
                  :
                  "Hapus"
                }
              </Buttons>
              <Buttons
                className="btn btn-default mr-2"
                onClick={() => setModal({ modal: false })}
                disabled={loading}
              >
                Batal
              </Buttons>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default ModalContent;
